var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconThumb = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 12,
  viewBox: "0 0 16 9"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#545252",
  d: "M8 8.584 11 5H5l3 3.584ZM0 0h16v5H0Z"
})));
export default SvgIconThumb;